module.exports = __webpack_public_path__ + "static/media/to_pearson.9d68d49a.jpg";